import { Component, Input } from '@angular/core';
import { RangeQuestionV3 } from '../../../classes/question-range';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-range-v3',
  templateUrl: './input-range.component.html',
  styleUrls: ['./input-range.component.scss'],
  standalone: false
})
export class InputRangeComponentV3 extends QuestionBaseV3ComponentDirective {
  @Input() question: RangeQuestionV3;
  @Input() color: string;

  get value() {
    return this.formGroup.get(this.question.key).value;
  }
}
